export default "/images/join-request-pending-icon.svg";